// extracted by mini-css-extract-plugin
module.exports = {"error":"ErrorComponent_error__1IgkZ"};